
import React from 'react';
import { AlertTriangle, Clock, Crown, Zap } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSubscription } from '@/contexts/SubscriptionContext';
import { useAuth } from '@/hooks/useAuth';
import DailyLimitReachedCard from './DailyLimitReachedCard';
import AdSection from './AdSection';

interface UsageLimitNoticeProps {
  remainingFiles: number;
  processedFiles: number;
  freeLimit: number;
  hasReachedLimit: boolean;
}

const UsageLimitNotice: React.FC<UsageLimitNoticeProps> = ({
  remainingFiles,
  processedFiles,
  freeLimit,
  hasReachedLimit
}) => {
  const { createCheckout, isPremium } = useSubscription();
  const { user } = useAuth();

  if (hasReachedLimit) {
    return (
      <div>
        <DailyLimitReachedCard
          processedFiles={processedFiles}
          freeLimit={freeLimit}
          isAuthenticated={!!user}
          className="mb-6"
        />
        {/* Show ad when limit is reached for free users */}
        <AdSection 
          adSlot="1234567896"
          adFormat="rectangle"
          position="middle"
          className="mb-4"
        />
      </div>
    );
  }

  if (remainingFiles <= 3 && remainingFiles > 0) {
    return (
      <div>
        <div className="bg-gradient-to-r from-yellow-50 to-orange-50 border-2 border-yellow-200 rounded-xl p-4 mb-6">
          <div className="flex items-center gap-3">
            <AlertTriangle className="w-6 h-6 text-yellow-600 flex-shrink-0" />
            <div className="flex-1">
              <p className="text-yellow-800 font-medium">
                Te quedan solo {remainingFiles} compresi{remainingFiles === 1 ? 'ón' : 'ones'} gratuita{remainingFiles === 1 ? '' : 's'} hoy
              </p>
              <p className="text-yellow-700 text-sm">
                Actualiza a Premium para comprimir imágenes ilimitadas
              </p>
            </div>
            <Button
              onClick={() => createCheckout('monthly')}
              size="sm"
              className="bg-yellow-600 hover:bg-yellow-700 text-white"
            >
              <Zap className="w-4 h-4 mr-1" />
              Premium
            </Button>
          </div>
        </div>
        {/* Show ad when approaching limit for free users */}
        {!isPremium && (
          <AdSection 
            adSlot="1234567897"
            adFormat="horizontal"
            position="middle"
            className="mb-4"
          />
        )}
      </div>
    );
  }

  return null;
};

export default UsageLimitNotice;
